export const defaultLanguage = "en";
export const fallbackLanguage = "en";
export const supportedLanguages = ["en", "pl"] as const;
export const defaultNameSpace = "";
export const namespaces = ["common"] as const;
